import PhoneOrder from "@/types/PhoneOrder.interface"

interface State {
    phoneOrder: PhoneOrder
}

const defaults = () => {
    return {
        phoneOrder: null
    }
}

export default {
    state: defaults(),
    mutations: {
        phoneOrderReset (state: State): void {
            Object.assign(state, defaults())
        },
        phoneOrderSet (state: State, order: PhoneOrder): void {
            state.phoneOrder = order
        },
    },
    actions: {
        phoneOrderPost ({ commit, getters }, payload: PhoneOrder): Promise<PhoneOrder> {
            //  Assemble the API endpoint
            const url = `${getters.api}/phone-order`

            //  Send our request
            return window.axios.post(url, payload).then(response => {
                //  Set our phone order in the store
                commit('phoneOrderSet', response.data)

                //  Return our created phone order
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        phoneOrder (state: State): PhoneOrder {
            return state.phoneOrder
        }
    }
}